import React from 'react';
import { motion } from 'framer-motion';
import image from "../../assets/individual.png";
import CartButton from '../CartButton';

const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
};

const buttonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5, delay: 0.5 } }
};

const imageVariants = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1.5 } }
};

function IndividualHero() {
    return (
        <section>
            <div className="flex px-6 md:px-20 items-center justify-center bg-hero md:h-screen overflow-hidden">
                <div className="flex flex-col gap-6 md:flex-row items-center max-w-8xl">
                    <motion.div
                        className="w-full md:w-1/2 lg:pr-32"
                        initial="hidden"
                        animate="visible"
                        variants={textVariants}
                    >
                        <h2 className="text-3xl lg:text-6xl text-center md:text-left text-blue-900 leading-tight font-bold lg:-mt-10 mt-6">
                            Discover courses tailored to your career goals
                        </h2>
                        <h3
                            className="mt-6 md:mt-10 text-md lg:text-xl text-center md:text-left text-gray-700 font-light tracking-wider leading-relaxed">
                            Join thousands of learners who are transforming their careers with Edumitram. Explore our range of courses and embark on a journey towards professional success.
                        </h3>
                        <div className="mt-10 flex flex-col sm:flex-row justify-center md:justify-start">
                            <motion.button
                                className="w-full sm:w-40 px-4 py-3 rounded font-semibold text-md bg-blue-500 text-white border-2 border-blue-500"
                                variants={buttonVariants}
                                initial="hidden"
                                animate="visible"
                            >
                                Get started
                            </motion.button>
                            <motion.button
                                className="w-full mt-4 sm:mt-0 sm:ml-4 sm:w-40 px-2 py-3 rounded font-semibold text-md bg-white text-blue-500 border border-gray-400/70 shadow-md shadow-gray-400/80"
                                variants={buttonVariants}
                                initial="hidden"
                                animate="visible"
                            >
                                Schedule a Demo
                            </motion.button>
                        </div>
                    </motion.div>
                    <motion.div
                        className="w-full md:w-1/2 flex justify-center md:justify-end"
                        initial="hidden"
                        animate="visible"
                        variants={imageVariants}
                    >
                        <img src={image} alt='individual-homepage' />
                    </motion.div>
                </div>
            </div>
            <CartButton />
        </section>
    )
}

export default IndividualHero;
